import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { checkHOD, checkHOU } from '../../permission-utils/settings';
import { request } from '../../services/utilities';
import { rosterAPI } from '../../services/constants';

const NurseMenu = () => {
	const [isSupervisor, setIsSuperVisor] = useState(false);
	const [isHOS, setIsHOS] = useState(false);

	const profile = useSelector(state => state.user.profile);
	const isItAdmin = profile?.role?.slug === 'it-admin';

	useEffect(() => {
		const fetchData = async () => {
			const isHOD = await checkHOD();
			const isHOU = await checkHOU();

			if (isHOD || isHOU) {
				setIsSuperVisor(true);
			}
		};

		fetchData();
	}, []);

	useEffect(() => {
		const checkHOS = async () => {
			try {
				const staffId = profile?.details?.id;
				const deptId = profile?.details?.department?.id;
				if (!staffId || !deptId) return;
				const period = moment().format('YYYY-MM');
				const today = moment().date();
				const hour = moment().hour();
				const currentShift = hour >= 8 && hour < 17 ? 'Morning' : 'Night';
				const uri = `${rosterAPI}/rosters?period=${period}&department_id=${deptId}&staff_id=${staffId}`;
				const rs = await request(uri, 'GET', true);
				if (rs?.length) {
					const schedule = rs[0]?.schedule || [];
					const todayEntry = schedule.find(s => s.schedule_date === today);
					if (todayEntry?.is_hos && todayEntry?.duty === currentShift) {
						setIsHOS(true);
					}
				}
			} catch (e) {
				// silently fail
			}
		};
		checkHOS();
	}, [profile]);

	const isNurse = profile?.role?.slug === 'nurse';

	return (
		<>
			{isSupervisor && (
				<li>
					<Link to="/nurse/overview">
						<div className="icon-w">
							<div className="icon-feather-home" />
						</div>
						<span>Overview</span>
					</Link>
				</li>
			)}
			{isNurse && (
				<li className="sub-header">
					<span>OUT-PATIENT</span>
				</li>
			)}
			<li>
				<Link to="/nurse">
					<div className="icon-w">
						<div className="icon-feather-home" />
					</div>
					<span>Vitals Queue</span>
				</Link>
			</li>
			<li>
				<Link to="/nurse/immunizations">
					<div className="icon-w">
						<div className="os-icon os-icon-documents-15" />
					</div>
					<span>Immunizations</span>
				</Link>
			</li>
			<li>
				<Link to="/nurse/all-immunizations">
					<div className="icon-w">
						<div className="os-icon os-icon-documents-15" />
					</div>
					<span>All Immunizations</span>
				</Link>
			</li>
			<li>
				<Link to="/nurse/out-patient-care">
					<div className="icon-w">
						<div className="icon-feather-folder-plus" />
					</div>
					<span>Out-Patient</span>
				</Link>
			</li>

			{isNurse && (
				<li className="sub-header">
					<span>IN-PATIENT</span>
				</li>
			)}
			<li>
				<Link to="/nurse/in-patients/admitted">
					<div className="icon-w">
						<div className="icon-feather-folder-plus" />
					</div>
					<span>In-Patient</span>
				</Link>
			</li>
			<li>
				<Link to="/nurse/in-patients/orders">
					<div className="icon-w">
						<div className="icon-feather-clipboard" />
					</div>
					<span>In-Patient Requests</span>
				</Link>
			</li>
			<li>
				<Link to="/nurse/in-patients/ward-requests">
					<div className="icon-w">
						<div className="icon-feather-alert-circle" />
					</div>
					<span>Ward Requests</span>
				</Link>
			</li>
			<li>
				<Link to="/nurse/in-patients/discharge-queue">
					<div className="icon-w">
						<div className="icon-feather-log-out" />
					</div>
					<span>Discharge Queue</span>
				</Link>
			</li>

			{isNurse && (
				<li className="sub-header">
					<span>TASKS</span>
				</li>
			)}
			<li>
				<Link to="/nurse/in-patients/tasks">
					<div className="icon-w">
						<div className="icon-feather-folder-plus" />
					</div>
					<span>Clinical Tasks</span>
				</Link>
			</li>

			{/* {(isItAdmin || (isNurse && (isSupervisor || isHOS))) && (
				<li>
					<Link to="/team/room-assignment">
						<div className="icon-w">
							<div className="os-icon os-icon-home" />
						</div>
						<span>Room Assignment</span>
					</Link>
				</li>
			)} */}

			{isNurse && (
				<li className="sub-header">
					<span>SPECIALTIES</span>
				</li>
			)}
			<li>
				<Link to="/nicu">
					<div className="icon-w">
						<div className="os-icon os-icon-documents-03" />
					</div>
					<span>NICU</span>
				</Link>
			</li>
			<li>
				<Link to="/ivf">
					<div className="icon-w">
						<div className="os-icon os-icon-documents-07" />
					</div>
					<span>IVF</span>
				</Link>
			</li>
			<li>
				<Link to="/antenatal/enrolled">
					<div className="icon-w">
						<div className="os-icon os-icon-documents-13" />
					</div>
					<span>Antenatal</span>
				</Link>
			</li>
			<li>
				<Link to="/labour-mgt">
					<div className="icon-w">
						<div className="os-icon os-icon-documents-15" />
					</div>
					<span>Labour Management</span>
				</Link>
			</li>
			{isItAdmin && (
				<li>
					<Link to="/nurse/room-management">
						<div className="icon-w">
							<div className="os-icon os-icon-database" />
						</div>
						<span>Room Management</span>
					</Link>
				</li>
			)}
		</>
	);
};

export default NurseMenu;
